
import {computed, defineComponent, PropType} from "vue";
import {Diamond} from "@/api/Diamond";
import useDiamondProperties from "@/composables/useDiamondProperties";
import {useI18n} from "vue-i18n";

export default defineComponent({
    name: "DiamondProperties",
    props: {
        diamond: {
            type: Object as PropType<Diamond>,
            required: true
        }
    },
    setup(props) {
        const {
            carat,
            clarity,
            color,
            cut,
            shape,
            productId
        } = useDiamondProperties(computed(() => props.diamond));

        return {...useI18n(), carat, clarity, color, cut, shape, productId};
    }
});
